import {
  Input,
  Select,
  Accordion,
  If,
  Loader
} from '@itau-loans-www/components'
import { cleanAccents } from '@itau-loans-www/utils'

import useBankDataForm from './hooks'

const BankDataForm = ({ control, formProps, isValid, initialValues }) => {
  const currentBank = formProps.watch('bank')
  const accountMaxLength = currentBank === '341 - BANCO ITAU S.A' ? '7' : '15'
  const { options, loading } = useBankDataForm(formProps, initialValues)

  return (
    <If
      condition={!loading}
      renderIf={
        <Accordion title="Seus dados bancários" initialOpen={!isValid}>
          <Select
            label="Nome do banco"
            name="bank"
            control={control}
            options={options}
            formProps={formProps}
            filterOptions={({ options, search }) => {
              return options.filter((option) =>
                cleanAccents(option.label)
                  .toLowerCase()
                  .includes(cleanAccents(search).toLowerCase())
              )
            }}
            onChange={(selectedOption) => {
              formProps.setValue('bank_code', selectedOption.value)
              formProps.trigger()
            }}
          />
          <Input.Text
            type="tel"
            label="Agência"
            id="branch"
            name="branch"
            autoComplete="on"
            maxLength="4"
            validators={{
              rules: {
                validate: {
                  onlyNumbers: (value) => /^[0-9*]+$/.test(value),
                  avoidIti: (value) => {
                    // regra de negocio no front:
                    // por enquanto, o banco não aceita banco digital
                    // alguns usuarios acham que iti e itau são a mesma coisa
                    // a agencia 500 é a agencia do iti
                    // assim, o time de negocios pediu para disparar um erro quando o usuario imputar 500
                    const isItauBank =
                      currentBank === '341 - BANCO ITAU S.A' ||
                      currentBank === '652 - ITAÚ UNIBANCO HOLDING BM S.A'
                    const isItiAccount = isItauBank && value === '500'

                    return !isItiAccount
                  }
                }
              },
              messages: {
                onlyNumbers: 'agência inválida',
                avoidIti:
                  'no momento não é possível receber em sua conta iti. informe outra conta.'
              }
            }}
            control={control}
            required
          />
          <Input.Text
            type="tel"
            label="Conta corrente"
            id="account_number"
            name="account_number"
            control={control}
            maxLength={accountMaxLength}
            validators={{
              rules: {
                validate: {
                  onlyNumbers: (value) => /^[0-9*]+$/.test(value)
                }
              },
              messages: {
                onlyNumbers: 'conta inválida'
              }
            }}
            required
          />
          <Input.Text
            label="Dígito"
            id="account_digit"
            name="account_digit"
            maxLength="1"
            control={control}
            validators={{
              rules: {
                validate: {
                  onlyNumbersAndX: (value) => /^[0-9xX]+$/.test(value)
                }
              },
              messages: {
                onlyNumbersAndX: 'digito inválido'
              }
            }}
            required
          />
        </Accordion>
      }
      renderElse={<Loader visible hasOverlay />}
    />
  )
}

export default BankDataForm
